module.exports = __webpack_public_path__ + "components/app-promo/static/en/snow-forecast__app-screenshot--1-9957f0e32907ed27eba53f6e87048464.jpg";